import script from "./AttachmentsBoard.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentsBoard.vue?vue&type=script&setup=true&lang=js"

import "./AttachmentsBoard.vue?vue&type=style&index=0&id=1bf8091f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bf8091f"]])

export default __exports__